if (!customElements.get('product-listing')) {
  const plpLoader = `
    <div class="loader flex items-center justify-center">
      <span class="block w-12 h-12">
        <svg class="animate-spin -ml-1 mr-3 h-full w-full text-accent1" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
      </span>
    </div>
  `;
  
  const accordionIcon = `
    <svg width="100%" height="100%" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 1L9 9L1 17" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
    </svg>
  `;
  
  const checkmarkIcon = `
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 12 9">
      <defs>
        <clipPath id="h9mzceli1a">
          <path data-name="Rectangle 45" d="M0 0h12v9H0z"></path>
        </clipPath>
      </defs>
      <path color="currentColor" fill="currentColor" data-name="Path 23" d="M3.94 9a.705.705 0 0 1-.506-.215L0 5.264l1.013-1.039 2.927 3L10.987 0 12 1.039 4.446 8.785A.705.705 0 0 1 3.94 9" style="clip-path:url(#h9mzceli1a)"></path>
    </svg>
  `;
  
  const xIcon = `
    <svg width="100%" height="100%" stroke="currentColor" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.00001 17L9 9.00001M9 9.00001L17 1M9 9.00001L1 1.00001M9 9.00001L17 17" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
    </svg>
  `;
  
  const renderSizeSelector = ({ values, id, name }) => {
    return values?.map((filterValue) => `
      <div class="rounded-sm border border-secondaryDark flex items-center justify-center w-11 h-11 overflow-hidden cursor-pointer relative">
        <input 
          data-action="apply-filter"
          id="filter-${filterValue[0]}-${id}" 
          type="checkbox" 
          class="absolute top-0 left-0 w-full h-full z-10 cursor-pointer opacity-0 peer" 
          value="${filterValue[0]}" 
          name="${name}"
          data-label="${name}: ${filterValue[0]}"
        >                   
        <span class="absolute top-0 left-0 w-full h-full z-1 transition duration-500 flex text-center items-center justify-center peer-hover:bg-primaryBody peer-hover:text-white peer-checked:bg-primaryBody peer-checked:text-white ">
          <span class="block">${filterValue[0]?.replace('|', '<br>').replace('Men', 'M').replace('Women', 'W')}</span>
        </span>
      </div>
    `).join('')
  }
  
  const renderTagSelector = ({ values, id, name, label }) => {
    return values?.map((tag) => `
      <div class="flex gap-[10px] items-center justify-start mb-3 last:mb-0">
        <div class="relative h-[22px] w-[22px] border border-fadedCornflower rounded-sm">
          <input 
            data-action="apply-filter"
            id="${tag.title}-${id}" 
            type="checkbox" 
            class="absolute top-0 left-0 w-full h-full z-10 cursor-pointer opacity-0 peer" 
            value="${tag.value}" 
            name="${name}"
            data-label="${label}: ${tag.title}"
          >
          <div class="bg-primaryBody text-white flex items-center absolute top-0 left-0 w-full h-full z-1 transition duration-500 justify-center opacity-0 peer-checked:opacity-100">
            <span class="block w-3">${checkmarkIcon}</span>
          </div>
        </div>
        <label for="${tag.title}-${id}" class="p-0 cursor-pointer flex gap-[6px]">
          ${tag.swatch ? `<div class="w-5 h-5">${tag.swatch}</div>` : ''}
          <span class="block text-primaryBody">${tag.title} (${tag.count})</span>
        </label>
      </div>
    `).join('')
  }
  
  const renderCategorySelector = ({ values, id, name }) => {
    return values?.map((filterValue) => `
      <div class="flex gap-[10px] items-center justify-start mb-3 last:mb-0">
        <div class="relative h-[22px] w-[22px] min-w-[22px] border border-secondaryDark rounded-sm">
          <input 
            data-action="apply-filter"
            id="filter-${filterValue[0]}-${id}" 
            type="checkbox" 
            class="absolute top-0 left-0 w-full h-full z-10 cursor-pointer opacity-0 peer" 
            value="${filterValue[0]}" 
            name="${name}"
            data-label="${JSON.stringify(filterValue[2]).replace(/[^A-Za-z0-9-\w\s]/g, '')}"
          >
          <div class="bg-primaryDark text-white flex items-center absolute top-0 left-0 w-full h-full z-1 transition duration-500 justify-center opacity-0 peer-checked:opacity-100">
            <span class="block w-3">${checkmarkIcon}</span>
          </div>
        </div>
        <label for="filter-${filterValue[0]}-${id}" class="p-0 cursor-pointer flex gap-[6px] ">
          <span class="block">${JSON.stringify(filterValue[2]).replace(/[^A-Za-z0-9-\w\s]/g, '')} (${filterValue[1]})</span>
        </label>
      </div>
    `).join('')
  }
  
  const renderStandardSelector = ({ values, id, name }) => {
    return values?.map((filterValue) => `
      <div class="flex gap-[10px] items-center justify-start mb-3 last:mb-0">
        <div class="relative h-[22px] w-[22px] border border-secondaryDark rounded-sm">
          <input 
            data-action="apply-filter"
            id="filter-${filterValue[0]}-${id}" 
            type="checkbox" 
            class="absolute top-0 left-0 w-full h-full z-10 cursor-pointer opacity-0 peer" 
            value="${filterValue[0]}" 
            name="${name}"
            data-label="${filterValue[0]}"
          >
          <div class="bg-primaryDark text-white flex items-center absolute top-0 left-0 w-full h-full z-1 transition duration-500 justify-center opacity-0 peer-checked:opacity-100">
            <span class="block w-3">${checkmarkIcon}</span>
          </div>
        </div>
        <label for="filter-${filterValue[0]}-${id}" class="p-0 cursor-pointer flex gap-[6px] ">
          <span class="block">${filterValue[0]} (${filterValue[1]})</span>
        </label>
      </div>
    `).join('')
  }
  
  const renderPriceSelector = ({ values, id, name }) => {
    return values?.map((filterValue) => `
      <div class="flex gap-[10px] items-center justify-start mb-3 last:mb-0">
        <div class="relative h-[22px] w-[22px] border border-secondaryDark rounded-sm">
          <input 
            data-action="apply-filter"
            id="filter-${filterValue[0]}-${id}" 
            type="checkbox" 
            class="absolute top-0 left-0 w-full h-full z-10 cursor-pointer opacity-0 peer" 
            value="${filterValue[0]}" 
            name="${name}"
            data-label="${filterValue[0]}"
          >
          <div class="bg-primaryDark text-white flex items-center absolute top-0 left-0 w-full h-full z-1 transition duration-500 justify-center opacity-0 peer-checked:opacity-100">
            <span class="block w-3">${checkmarkIcon}</span>
          </div>
        </div>
        <label for="filter-${filterValue[0]}-${id}" class="p-0 cursor-pointer flex gap-[6px] ">
          <span class="block">${transformPriceLabel(filterValue[0])} (${filterValue[1]})</span>
        </label>
      </div>
    `).join('')
  }
  
  const renderAccordionFilters = ({ label, id, renderSelector, index }) => `
    <div style="order: ${index}">
      <button 
        data-label="${label}"
        data-independent
        data-accordion-toggle="${label}-${id}" 
        class="text-primaryBody flex items-center justify-between w-full rounded-none border-t border-fadedCornflower px-4 xl:px-0 py-5 font-bold whitespace-nowrap"
      >
        ${label}
        <div aria-hidden="true" class="relative">
          <span data-rotate-active="270" class="transform rotate-90 transition duration-500 w-2 block">${accordionIcon}</span>
        </div>
      </button>
      <div 
        data-label="${label}"
        style="height: 0;" 
        data-accordion-content="${label}-${id}" 
        class="transition-all overflow-hidden duration-500"
      >
        <div class="pb-5 px-4 xl:px-0 ${label.toLowerCase().trim().includes('size') ? 'flex gap-[10px] items-center justify-start flex-wrap' : ''}">
          ${renderSelector()}
        </div>
      </div>
    </div>
  `;
  
  const renderRemoveFilterButton = () => `
    <div class="w-full py-4 hidden md:block">
      <button 
        data-filter-value="all"
        data-action="remove-filter"
        class="pb-1 font-bold underline whitespace-nowrap"
      >
        Clear All
      </button>
    </div>
  `;
  
  const renderRemoveSpecificFilterButton = ({ value, label, name }) => `
    <button 
      data-filter-value="${value}"
      data-action="remove-filter"
      class="whitespace-nowrap flex border p-2 xl:p-2.5 border-current rounded-lg items-center justify-center gap-[6px] relative h-8"
    >
      <span class="w-2 h-2">${xIcon}</span>
      ${name == 'Price' ? 'Price: ' + transformPriceLabel(label) : label}
    </button>
  `;

  const transformPriceLabel = (str) => {
    return str
      .replace(/[A-Z]{3}:(\d+(\.\d+)?)-[A-Z]{3}:(\d+(\.\d+)?)/, (_1, num1, _2, num2) => {
        const newNum1 = Math.floor(parseFloat(num1) *  Number(Shopify.currency.rate)).toFixed(1);
        const newNum2 = Math.floor(parseFloat(num2) *  Number(Shopify.currency.rate)).toFixed(1);
        return `$${newNum1} - $${newNum2}`;
      })
      .replace(/\.0/g, ''); // Removes the .0 from the numbers
  };
  
  class ProductListing extends HTMLElement {
    constructor() {
      super();
      this.filtersLoaded = false;
      this.id = null;
      this.sortBy = null;
      this.page = 1;
      this.narrowBy = [];
      this.hasGenderToggle = false;
      this.drawerOpen = false;
    }
    
    connectedCallback() {
      if (!this.isConnected) return;
      this.id = this.dataset.id;
      
      poll(() => {
        return window.FastSimonSDK;
      }, 10000, 150).then(() => {
        this.syncFiltersFromUrl();
        this.klaviyoID = __isp_get_customer_identifier_from_klaviyo();
      }).catch((err) => {
        console.error('Fast Simon took too long to load.', err)
      });
      
      if (!window.matchMedia('(min-width: 1200px)').matches) this.classList.remove('expanded');
      document.addEventListener('DOMContentLoaded', () => {
        setTimeout(() => {
          this.classList.add('loaded')
        }, 500);
      });
      
      window.addEventListener('resize', () => {
        if (window.matchMedia('(min-width: 1200px)').matches) {
          this.classList.add('expanded');
          document.body.classList.remove('overlay');
          return;
        }   
        this.classList.remove('expanded');     
      });
            
      // catch product clicks to send to Fast Simon for analytics
      this.addEventListener('click', (e) => {
        if (!e.target.closest('[data-product-url][data-product-id][href]')) return;
        
        e.preventDefault();
        const anchor = e.target.closest('[data-product-url][data-product-id][href]');
        const index = [...this.querySelectorAll('[data-product-url][data-product-id][href]')]
          .findIndex(({ href }) => href === anchor.href);
                              
        if (this.id === 'search') {
          const searchParams = new URLSearchParams(window.location.search);
          const term = searchParams.get('q');
          
          window.FastSimonSDK.event({
            eventName: window.FastSimonEventName.SerpProductClicked,
            data: {
              kl_id: this.klaviyoID,
              query: term, // (Required)
              productID: anchor.dataset.productId, // (Required)
              position: index + 1 // counted from 1
            }
          }); 
        } else {
          window.FastSimonSDK.event({
            eventName: window.FastSimonEventName.CollectionProductClicked,
            data: {
              kl_id: this.klaviyoID,
              collectionID: this.id, // (Required)
              productID: anchor.dataset.productId, // (Required)
              position: index + 1, // counted from 1
              query: undefined // Default = Collection_Name 
            }
          }); 
        }
        
        window.location.href = anchor.href;
      });

      //Weird tab redirect from sort-by to gender
      const sortBySelect = this.querySelector('select[data-param-name="sort_by"]');
      const genderElement = this.querySelector('[data-gender-select]');
      const filtersWrapOuter = this.querySelector('[data-filters-wrap-outer]');
      
      setTimeout(() => {
        if (genderElement && genderElement.offsetParent !== null && window.innerWidth > 1280) {
          sortBySelect.addEventListener('focusin',() => {
            sortBySelect.addEventListener('focusout', function (event) {
              if (event.relatedTarget.closest('[data-filters-wrap] button')) {
                event.preventDefault();
                genderElement.querySelector('input[type="radio"]:checked').focus();
              }
            }, { once: true});
          });
          
          genderElement.addEventListener('focusin',() => {
            genderElement.addEventListener('focusout', function (event) {
              if (event.relatedTarget.closest('[data-products-wrap] a')) {
                const firstFocusable = filtersWrapOuter.querySelector(
                    'a, button:not([data-action="toggle-filters"]), input, select, textarea, [tabindex]:not([tabindex="-1"])'
                );
                if (firstFocusable) {
                  event.relatedTarget.blur();
                  firstFocusable.focus();
                }
              }
            }, { once: true});
          });
        }
      }, 1000);
      
      ['click', 'change', 'apply-filter'].forEach((eventType) => {
        this.addEventListener(eventType, debounce((e) => {
          const clickedElement = e.target.closest('[data-action]');
          if (!clickedElement && eventType !== 'apply-filter') return; 
          
          const productsWrap = this.querySelector('[data-products-wrap]');
          const newURL = new URL(window.location);
          let action, filterValue;
          
          if (clickedElement) {
            action = clickedElement.dataset.action;
            filterValue = clickedElement.dataset.filterValue;
          } else action = 'apply-filter';
          
          switch (action) {
            case 'sort':
              if (this.sortBy === clickedElement.value || clickedElement.value === 'Sort By') return;
              productsWrap.innerHTML = '';
              this.sortBy = clickedElement.value;
              newURL.searchParams.set('sortBy', clickedElement.value);
              window.history.replaceState({}, 'Sort applied', newURL.toString());
              this.loadPage();
            break;
            case 'apply-filter':
              const appliedFilters = [... new Set([...this.querySelectorAll('input[data-action="apply-filter"]:checked')])];
              const unappliedFilters = [... new Set([...this.querySelectorAll('input[data-action="apply-filter"]:not(:checked)')])];
              const appliedFiltersWrap = this.querySelector('[data-applied-filters-wrap]');
              productsWrap.innerHTML = '';
              
              const prevNarrowBy = [...this.narrowBy];
              this.classList.remove('fully-loaded');
              this.page = 1;
              this.narrowBy = [];
              appliedFiltersWrap.innerHTML = '';
              
              const maxPrice = this.querySelector('input[name="Price_max"]')?.value;
              const minPrice = this.querySelector('input[name="Price_min"]')?.value;
              if (maxPrice && minPrice) {
                this.narrowBy.push(['Price_from_to', `${minPrice}-${maxPrice}`]);
              }
              
              // if the filter is not active, remove it from the url
              for (let i = 0; i < unappliedFilters.length; i++) {
                const filter = unappliedFilters[i];
                const paramsFromFilters = [... newURL.searchParams.getAll(filter.name)];
                newURL.searchParams.delete(filter.name);
                paramsFromFilters.forEach((value) => {
                  if (value !== filter.value) {
                    newURL.searchParams.append(filter.name, value);
                  }
                });
              }

              // add active filters to the url
              for (let i = 0; i < appliedFilters.length; i++) {
                const filter = appliedFilters[i];
                const paramsFromFilters = [... newURL.searchParams.getAll(filter.name)];
                
                this.narrowBy.push([filter.name, filter.value]);
                if (!paramsFromFilters.find((value) => value === filter.value) && this.narrowBy.find((x) => x[1] === filter.value)) {
                  newURL.searchParams.append(filter.name, filter.value);
                }
                appliedFiltersWrap.insertAdjacentHTML('beforeend', renderRemoveSpecificFilterButton({ value: filter.value, label: filter.dataset.label, name: filter.name }));
              }
              
              window.history.replaceState({}, 'Filters applied', newURL.toString());
              
              if (appliedFilters.length) appliedFiltersWrap.insertAdjacentHTML('beforeend', renderRemoveFilterButton());
              
              this.loadPage();
            break;
            case 'remove-filter':
              if (filterValue === 'all') {
                this.querySelectorAll(`[data-action="apply-filter"]:checked`).forEach(radio => radio.click());
                return;
              }
              
              for (const key of newURL.searchParams.keys()) {
                const value = newURL.searchParams.get(key);
                if (value === filterValue) {
                  newURL.searchParams.delete(key);
                  window.history.replaceState({}, 'Filters removed', newURL.toString());
                }
              }
              
              this.querySelector(`[data-action="apply-filter"][value="${filterValue}"]:checked`)?.click();
            break;
            case 'toggle-filters':
              this.drawerOpen = !this.drawerOpen;
              this.classList.toggle('expanded');
              if (window.matchMedia('(min-width: 1024px)').matches) return;
              document.getElementById('MainContent').classList.toggle('z-0');
              document.body.classList.toggle('overlay');
              if (this.drawerOpen)
                document.querySelector('[data-filters-wrap-outer] [data-action="toggle-filters"]').focus();
            break;
            case 'load-more':
              this.page = this.page + 1;
              newURL.searchParams.set('page', this.page);
              window.history.replaceState({}, 'Pagination applied', newURL.toString());
              this.loadPage();
            break;
            case 'seo-more':
              this.querySelector("[data-seo-footer]").classList.remove("max-h-[500px]", "lg:max-h-[300px]", "overflow-hidden");
              this.querySelector("[data-seo-read-less]").classList.remove("hidden");
              this.querySelector("[data-seo-read-more]").classList.add("hidden");
            break;
            case 'seo-less':
              this.querySelector("[data-seo-footer]").classList.add("max-h-[500px]", "lg:max-h-[300px]", "overflow-hidden");
              this.querySelector("[data-seo-read-less]").classList.add("hidden");
              this.querySelector("[data-seo-read-more]").classList.remove("hidden");
            break;
            default: break;
          }
        }, 100));  
      })    
    }
    
    syncFiltersFromUrl() {
      const newURL = new URL(window.location);
      const sortBy = newURL.searchParams.get('sortBy');
      for (const key of newURL.searchParams.keys()) {
        const values = newURL.searchParams.getAll(key);
        values.map((value) => {
          const filterInput = this.querySelector(`input[name="${key}"][value="${value}"]`);
          if (filterInput) {
            this.narrowBy.push([key, value]);
            filterInput.checked = true;
          }
        });
      }
      
      const maxPrice = this.querySelector('input[name="Price_max"]')?.value;
      const minPrice = this.querySelector('input[name="Price_min"]')?.value;
      if (maxPrice && minPrice) {
        this.narrowBy = this.narrowBy.filter(subarray => {
          return subarray[0] !== 'Price_from_to';
        });
        this.narrowBy.push(['Price_from_to', `${minPrice}-${maxPrice}`]);
      }
      
      if (sortBy) {
        this.sortBy = sortBy;
        this.querySelectorAll('select[data-action="sort"]').forEach(select => select.value = sortBy);
      }
      
      setTimeout(() => {
        this.dispatchEvent(new CustomEvent('apply-filter'));
      }, 100);
    }
    
    renderFilters(filters) {
      const filterWrap = document.createElement('div');
      filters.forEach((filter, i) => {
        const filterUUID = uuidv4();
        switch (filter[2]) {
          case 'Price':
            filterWrap.insertAdjacentHTML('beforeend', renderAccordionFilters({ 
              label: filter[2], 
              id: filterUUID, 
              index: i,
              renderSelector: () => renderPriceSelector({ values: filter[1], id: filterUUID, name: filter[0] })
            }));
          //   const minFilter = filters.find((arr) => arr.some(val => val === "Price_min"))?.[1];
          //   const maxFilter = filters.find((arr) => arr.some(val => val === "Price_max"))?.[1];

          //   filterWrap.insertAdjacentHTML('beforeend', renderAccordionFilters({ 
          //     label: filter[2], 
          //     id: filterUUID, 
          //     index: i,
          //     renderSelector: () => renderPriceSelector({ 
          //       values: { 
          //         min: minFilter, 
          //         max: maxFilter
          //       }, 
          //       id: filterUUID, 
          //       name: filter[0] 
          //     })
          //   }));
          break;
          case 'Price_min':
            // handled in price
          break;
          case 'Price_max':
            // handled in price
          break;
          case 'Size':
            filterWrap.insertAdjacentHTML('beforeend', renderAccordionFilters({ 
              label: filter[2], 
              id: filterUUID, 
              index: i,
              renderSelector: () => renderSizeSelector({ values: filter[1], id: filterUUID, name: filter[0] })
            }));
          break;
          case 'Color':
            const colorTagsToRender = [];
            for (let i = 0; i < colors.length; i++) {
              const colorArr = colors[i].split(':');
              const title = colorArr[0];
              const value = colorArr[1];
              const filterToRender = filter[1]?.find((filterValueArr) => filterValueArr[0] === value);
              if (!filterToRender) continue;
              colorTagsToRender.push({ title, value, swatch: colorsSwatches[title], count: filterToRender[1] });        
            }
                        
            if (colorTagsToRender.length) {
              filterWrap.insertAdjacentHTML('beforeend', renderAccordionFilters({ 
                label: 'Color', 
                id: filterUUID, 
                index: i,
                renderSelector: () => renderTagSelector({ values: colorTagsToRender, id: filterUUID, name: filter[0], label: 'Color' })
              }));
            }
          break;
          case 'Gender':
            const genderTagsToRender = [];
            for (let i = 0; i < genders.length; i++) {
              const genderArr = genders[i].split(':');
              const title = genderArr[0];
              const value = genderArr[1];
              const filterToRender = filter[1]?.find((filterValueArr) => filterValueArr[0] === value);
              if (!filterToRender) continue;
              genderTagsToRender.push({ title, value, count: filterToRender[1] });     
            }
            
            this.hasGenderToggle = ['womens', 'mens'].every(gender =>
              genderTagsToRender.some(x => x.value === gender)
            );            
            
            this.classList.toggle('has-gender-toggle', this.hasGenderToggle);
            
            if (genderTagsToRender.length) {
              filterWrap.insertAdjacentHTML('beforeend', renderAccordionFilters({ 
                label: 'Gender', 
                id: filterUUID, 
                index: i,
                renderSelector: () => renderTagSelector({ values: genderTagsToRender, id: filterUUID, name: filter[0], label: 'Gender' })
              }));
            }
          break;
          case 'Categories':
            filterWrap.insertAdjacentHTML('beforeend', renderAccordionFilters({ 
              label: filter[2], 
              id: filterUUID, 
              index: i,
              renderSelector: () => renderCategorySelector({ values: filter[1], id: filterUUID, name: filter[0] })
            }));
          break;
          default:
            filterWrap.insertAdjacentHTML('beforeend', renderAccordionFilters({ 
              label: filter[2], 
              id: filterUUID, 
              index: i,
              renderSelector: () => renderStandardSelector({ values: filter[1], id: filterUUID, name: filter[0] })
            }));
          break;
        }
      });
      
      return filterWrap;
    }
    
    loadFilters(filters) {
      if (!filters) return;
      const filterWrap = this.querySelector('[data-filters-wrap]');
      
      if (this.filtersLoaded) {
        const newHtml = this.renderFilters(filters);
        if (filterWrap.innerHTML.toString() === newHtml.toString()) return;
        
        const appliedFilters = [...new Set([...this.querySelectorAll('input[data-action="apply-filter"]:checked')])]
          .map((input) => ({ name: input.name, value: input.value }));

          appliedFilters.forEach(({ name, value }) => {
          newHtml.querySelectorAll(`input[data-action="apply-filter"][name="${name}"][value="${value}"]`)
            .forEach((input) => {
              input.setAttribute('checked', true);
            });
        });
        
        newHtml.querySelectorAll('.duration-500')
          .forEach((el) => el.classList.replace('duration-500', 'duration-0'));
        filterWrap.querySelectorAll(':scope > div > *').forEach((el) => el.remove());

        filterWrap.insertAdjacentHTML('beforeend', newHtml.innerHTML);

        [...this.querySelectorAll('[data-accordion-toggle]:not([data-label="Size"]):not([data-label="Color"])')]
          .find((button) => {
            if (button.nextElementSibling.querySelectorAll('input[data-action="apply-filter"]:checked').length > 0) button.click();
          });
        this.querySelector('[data-label="Size"]')?.click()
        this.querySelector('[data-label="Color"]')?.click()
          
        filterWrap.querySelectorAll('.duration-0')
          .forEach((el) => el.classList.replace('duration-0', 'duration-500'));
          
        window.dispatchEvent(new CustomEvent('filters-rendered'));

        return;
      }
      
      filterWrap.innerHTML = this.renderFilters(filters)?.innerHTML;
      const sortBy = this.querySelector('select[name="sort_by"]');
      
      if (sortBy && window.FastSimonSortBy) {
        const titleLookup = {
          PriceLowToHigh: 'Price Low to High',
          PriceHighToLow: 'Price High to Low',
          NewFirst: 'Newest',
          OldFirst: 'Oldest',
          AtoZ: 'A to Z',
          ZtoA: 'Z to A',
          relevancy: 'Relevant'
        };
        
        sortBy.closest('[data-sort-wrap]')?.classList.remove('hidden');
        
        sortBy.innerHTML = `<option ${this.sort ? '' : 'selected'} disabled>Sort By</option>`;
        sortBy.insertAdjacentHTML('beforeend', Object.keys(window.FastSimonSortBy)
          .map((key) => `
            <option 
              ${window.FastSimonSortBy[key] === this.sort ? 'selected' : ''} 
              value="${window.FastSimonSortBy[key]}"
            >
              ${titleLookup[key] || key}
            </option>
          `));
      } else if (sortBy && !window.FastSimonSortBy) {
        sortBy.closest('[data-sort-wrap]')?.classList.add('hidden');
      }
      if (!this.filtersLoaded) {
        const sizeButton = this.querySelector('[data-label=Size]');
        const colorButton = this.querySelector('[data-label=Color]');
        sizeButton?.click();
        colorButton?.click();
      }

      this.filtersLoaded = true;
      this.syncFiltersFromUrl();
      window.dispatchEvent(new Event('FastSimon:plp-update', { bubbles: true }));
    }
    
    renderResults(response) {
      const productsWrap = this.querySelector('[data-products-wrap]');
      const collectionInfo = this.querySelector('[data-collection-info]');
      const collectionInfoWrapper = this.querySelector('[data-load-more-wrap]');
      const promoTemplate = document.querySelector('[data-promo-tile]');
      const promoPos = Number(promoTemplate?.dataset.promoTile);
      
      productsWrap.querySelector('[data-loading-skeleton]')?.remove();
             
      if ((this.page >= response.payload.pageCount) || !response.payload.totalResults) {
        this.classList.add('fully-loaded');
      } else {
        this.classList.remove('fully-loaded');
      }
      
      if (!response.payload.totalResults) {
        this.classList.add('no-results');
      } else {
        this.classList.remove('no-results');
      }
      
      collectionInfoWrapper.classList.remove('loading');
      const productsPerPage = response.payload.products.length;
      collectionInfo.innerHTML = `Showing <span class="font-bold">${productsPerPage * this.page}</span> of <span class="font-bold">${response.payload.totalResults}</span> products`;
      
      this.querySelectorAll('[data-results-wrap]').forEach((el) => {
        el.innerHTML = response.payload.totalResults; 
      });
      
      if (this.page === 1) productsWrap.innerHTML = '';
      for (let i = 0; i < response.payload.products.length; i++) {
        const product = response.payload.products[i];
        if (productsWrap.querySelector(`[href="${product.u}"]`) || productsWrap.querySelector(`[data-url="${product.u}"]`)) return;
        
        productsWrap.insertAdjacentHTML('beforeend', `
          ${((promoPos - 1) === i) ? promoTemplate.cloneNode(true).innerHTML : ''}
          <intersection-loader 
            data-url="${product.u}" 
            data-section-id="product-tile"
          >${plpLoader}</intersection-loader>
        `);
      };
      
      const productResponse = response.payload.products
      const productList = []
      const list = localStorage.getItem("___ELEVAR_GTM_SUITE--lastCollectionPathname");
      const cat = list?.replace('/collections/', '' )?.replace('-', ' ').toUpperCase();
      
      productResponse.forEach((product, index) => {
        let variantName = product.l.split(' - ');
        let variantID = product.s.split('::');
        let item = {
          id: product.sku,
          name: product.l,
          brand: product.v,
          category: cat,
          variant: variantName[1],
          list: list,
          product_id: product.id,
          variant_id: variantID[1],
          price: product.p,
          compare_at_price: product.p_c,
          position: index+1
        };
        productList.push(item)
      });
    }
    
    async loadPage() {
      const collectionInfoWrapper = this.querySelector('[data-load-more-wrap]');
      collectionInfoWrapper.classList.add('loading');
    
      return new Promise((resolve, reject) => {
        if (this.id === "search") {
          const searchParams = new URLSearchParams(window.location.search);
          const term = searchParams.get('q');
    
          window.FastSimonSDK.fullTextSearch({
            term: term,
            page: this.page,
            productsPerPage: 48,
            narrowBy: this.narrowBy,
            sortBy: this.sortBy,
            callback: (response) => {
              this.renderResults(response);
              this.loadFilters(response.payload.facets);
    
              window.FastSimonSDK.event({
                eventName: window.FastSimonEventName.SearchPerformed,
                data: {
                  kl_id: this.klaviyoID,
                  query: term,
                  narrowBy: this.narrowBy,
                  sortBy: this.sortBy,
                  products: response.payload.products.map(({ id }) => id).toString(),
                  rescount: response.payload.totalResults,
                  pagenum: Math.ceil(response.payload.totalResults / 48)
                }
              });
    
              collectionInfoWrapper.classList.remove('loading');
              resolve(); // Resolve the promise when done
            },
            error: (err) => {
              collectionInfoWrapper.classList.remove('loading');
              reject(err); // Reject the promise on error
            }
          });
        } else {
          const isTurbo = sessionStorage.getItem('isTurbo') === 'true' ? true : false;
          sessionStorage.setItem('isTurbo', false); 
          window.FastSimonSDK.smartCollections({
            categoryID: this.id,
            page: this.page,
            narrowBy: this.narrowBy,
            sortBy: this.sortBy,
            productsPerPage: 48,
            callback: (response) => {
              this.renderResults(response);
              this.loadFilters(response.payload.facets);
    
              window.FastSimonSDK.event({
                eventName: window.FastSimonEventName.SmartCollectionPreformed,
                data: {
                  kl_id: this.klaviyoID,
                  categoryID: this.id,
                  narrowBy: this.narrowBy,
                  sortBy: this.sortBy,
                  products: response.payload.products.map(({ id }) => id).toString(),
                  rescount: response.payload.totalResults,
                  pagenum: Math.ceil(response.payload.totalResults / 48),
                  fromTurboLink: isTurbo
                }
              });
    
              collectionInfoWrapper.classList.remove('loading');
              resolve(); // Resolve the promise when done
            },
            error: (err) => {
              collectionInfoWrapper.classList.remove('loading');
              reject(err); // Reject the promise on error
            }
          });
        }
      });
    }
    
  }
  
  customElements.define('product-listing', ProductListing);
}